module.exports = __webpack_public_path__ + "media/images/icons/icons_large/4_cupcake-b135b079c4c58d508e0002bf3ceedf75.png";